// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../types';

export default styled<any, Theme>('div')`
  background: ${props => props.theme.configChoice.errorBackground};
  color: ${props => props.theme.configChoice.errorColor};
  border-radius: ${props => props.theme.configChoice.errorBorderRadius};
  margin: .25rem .5rem 1rem;
  padding: .5rem;
`;
